import React from "react";
import "../../styles/components.css";

const PageNavigation = ({
  currentPage,
  totalPages,
  onPrevious,
  onNext,
  onSubmit,
}) => {
  const isLastPage = currentPage === totalPages;

  return (
    <div className="page-navigation">
      <button
        className="nav-button previous"
        onClick={onPrevious}
        disabled={currentPage === 1}
      >
        <span className="nav-icon">←</span>
        <span className="nav-text">Prev</span>
      </button>

      {isLastPage ? (
        <button className="nav-button submit" onClick={onSubmit}>
          <span className="submit-text">Submit</span>
          <span className="submit-subtext">작성 완료</span>
        </button>
      ) : (
        <div className="page-indicator">
          {currentPage} / {totalPages}
        </div>
      )}

      <button
        className="nav-button next"
        onClick={onNext}
        disabled={isLastPage}
      >
        <span className="nav-text">Next</span>
        <span className="nav-icon">→</span>
      </button>
    </div>
  );
};

export default PageNavigation;
